var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",on:{"click":_vm.handleFullRemoteClick}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icons/fullRemote.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(_vm._s(_vm.$t('editButtonOrderPageFullRemote')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }